import { InjectionToken } from '@angular/core';


export interface AppConfig {
	envName: string;
	buildVer: string;
	appVersion: string;
	insightKey: string;
	domainPatientAPI: string;
	domainUserAPI: string;
	domainImageAPI: string;
	domainRayAPI: string;
	domainIntegrationAPI: string;
	sseAPI: string;
	cdnUrl: string;
	b2cTenantName: string;
	b2cTenantId: string;
	b2cSignInPolicyId: string;
	b2cResetPasswordPolicyId: string;
	b2cChangePasswordPolicyId: string;
	b2cClientId: string;
	b2cApplicationScope: string;
	appSSOutUriApi: string;
	idleTimeToEndSession: number;
	patplanSite: string;
	planDetailsSite: string;
	legalTermsSite: string;
	aboutSite: string;
	guideSite: {
		baseUrl: string;
		list: string;
	};
	helpSite: {
		baseUrl: string;
		fileNames: string;
	};
	eifuSite: string;
	templatesSite: string;
	rayModelVersion: string;
	resetSubscriptionTimeout: number;
	cookieName: string;
	minScreenResolution: {
		width: number;
		widthTolerance: number;
		height: number;
		heightTolerance: number;
		mobilePhoneWidth: number;
	};
}

export const APP_CONFIG = new InjectionToken<AppConfig>('AppConfig');

let appConfig: AppConfig;

export function initializeAppConfig(config: AppConfig) {
	appConfig = config;
}

export function getAppConfig(): AppConfig {
	if (!appConfig) {
		throw new Error('AppConfig not initialized!');
	}
	return appConfig;
}


export enum PAGE {
	ERROR = 'error'
}